import { addMonths, setDate, startOfMonth, format } from 'date-fns'
import { RangePrice } from '~services/interfaces'

export function getNextRenewDay(renewDay: number) {
  if (!renewDay) return ''

  const today = new Date()
  const nextMonth = addMonths(startOfMonth(today), 1)
  const nextRenewDate = setDate(nextMonth, renewDay)

  return `(${format(nextRenewDate, 'dd/MM')})`
}


export function shouldDisplaySavings(rangePrice: RangePrice[]) {
  return rangePrice[0].amount === 1
}